export const PageTitle = props => {
    return (
        <div className="border-bottom ml-2 mb-4 h2 p-2">
            { props.title }
        </div>
    )
};